import React, { createContext, useContext, useEffect, useState } from "react";
import { getPicklistItems } from "../utils/getPicklistItems";

const PicklistContext = createContext();

export const usePicklist = () => {
	return useContext(PicklistContext);
};

export const PicklistProvider = ({ children }) => {
	const externalReferenceCodes = {
		BLOODTYPE: "BLOODTYPE",
		CURRENTSTATE: "CURRENTSTATE",
		CIVILSTATUS: "CIVILSTATUS",
		ORGAO: "ORGAO",
		EDUCATIONLEVEL: "EDUCATIONLEVEL",
		GENDER: "GENDER",
		SITUATION: "SITUATION",
		UF: "UF",
	};

	const [loading, setLoading] = useState(true);
	const [picklistItems, setPicklistItems] = useState([]);

	const getPicklistByCode = (externalReferenceCode) => {
		if (!picklistItems.items) {
			return []; 
		}

		return picklistItems.items
			.filter(
				(item) => item.externalReferenceCode === externalReferenceCode
			)
			.flatMap((item) =>
				item.listTypeEntries.map((entry) => ({
					key: entry.key,
					name: entry.name,
					name_i18n:
						typeof entry.name === "object"
							? entry.name.default || entry.name?.["pt-BR"]
							: entry.name,
				}))
			);
	};

	useEffect(() => {
		async function fetchPicklist() {
			try {
				const items = await getPicklistItems();
				setPicklistItems(items);
			} catch (error) {
				console.error("Error fetching picklist items:", error);
			} finally {
				setLoading(false);
			}
		}
		fetchPicklist();
	}, []);

	return (
		<PicklistContext.Provider
			value={{
				loading,
				getPicklistByCode,
				externalReferenceCodes,
			}}
		>
			{children}
		</PicklistContext.Provider>
	);
};
